// src/components/Topbar.jsx
import React from "react";
import "../css/Topbar.css";
import GlobalBreadcrumbs from "./GlobalBreadcrumbs";
import { theme } from "../theme/theme";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from '../constants'


const Topbar = () => {
    const navigate = useNavigate();
  
    const handleLogout = () => {
      Cookies.remove("authToken");
      Cookies.remove("user_type");
      window.location.reload(); // Refresh the page to update state
      // setIsLoggedIn(false);
      navigate("/");
    };
  return (
    <header className="topbar"  >
      <GlobalBreadcrumbs />
  
      <div style={{width:'auto', margin: '0 1rem', display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
        <div style={{display:'flex', minWidth:'fit-content', alignItems:'center', justifyContent:'center', backgroundColor:`${theme.colors.secondary}10`, padding:'5px 10px', borderRadius:'1rem', marginRight:'1rem'}}>
        <i className="fa-solid fa-user" style={{marginRight:'0.5rem', color:theme.colors.background, backgroundColor:theme.colors.primary, padding:'5px', borderRadius:'50%'}}></i>
        <span style={{marginRight:'1rem', color:theme.colors.secondary, fontWeight: '500', fontSize: theme.font.size.large}}>Welcome</span>

        </div>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="logout-tooltip">Logout</Tooltip>}
      >
        <div
          className="profile-pic"
          style={{
            color: theme.colors.error,
            backgroundColor: `${theme.colors.error}10`,
            cursor: "pointer",
            padding: "5px 8px",
            border: `1px solid ${theme.colors.error}`,
            borderRadius: "5px",
            fontSize: "0.9rem",
            fontWeight: "500",
          }}
          onClick={handleLogout}
        >
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
        </div>
      </OverlayTrigger>
      </div>

    </header>
  );
};

export default Topbar;
